import { searchTypes, searchParams } from "../../config/constants";
import { ISearchParams } from "../../interfaces/ISearchDocumentLibraryParameter";
import { DriveItemSearchResultComposite } from "../../interfaces/DriveItemSearchResultComposite";
import { IMapper } from "../../interfaces/IMapper";
import { axiosRetryPost } from "../../../../utilities/AxiosRetryUtil";

export class GraphSearchRestHelper {
    options: {};
    body: string;
    constructor(private url: string, private mapper: IMapper<DriveItemSearchResultComposite>) { }

    setHeader = (accessToken: string) => {
        this.options = {
            headers: {
                "Authorization": "Bearer " + accessToken,
                'Content-Type': 'application/json',
            }
        };

        return this;
    }

    setBody = (searchParameter: ISearchParams) => {
        this.body = JSON.stringify({
            requests: [
                {
                    entityTypes: [
                        searchTypes.driveItem
                    ],
                    query: {
                        queryString: this.buildQuery(searchParameter)
                    },
                    from: !searchParameter.pageIndex ? 0 : searchParameter.pageIndex * searchParams.maxSize,
                    size: searchParams.maxSize
                }
            ],
        });

        return this;
    }

    private buildQuery(searchParameter: ISearchParams) {
        if (!searchParameter.webUrl) {
            return `${searchParameter.searchValue} Size>0`;
        }

        if (!searchParameter.directory) {
            return `${searchParameter.searchValue} Size>0 path:\"${searchParameter.webUrl}\"`
        }

        return `${searchParameter.searchValue} Size>0 path:\"${searchParameter.webUrl}/${searchParameter.directory}\"`;
    }

    Execute = async () => {
        const result = await axiosRetryPost(this.url, this.body, this.options);
        return this.mapper.map(result.data.value);
    }
}